var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { createContext } from 'react';
import { useRoutes } from 'react-router-dom';
export var AppRoutesContext = createContext([]);
export function AppRoutes(_a) {
    var routes = _a.routes, fallback = _a.fallback;
    var routeElements = useRoutes(routes);
    return (_jsx(AppRoutesContext.Provider, __assign({ value: routes }, { children: fallback ? (_jsx(Suspense, __assign({ fallback: fallback }, { children: routeElements }))) : (routeElements) })));
}
